import React from 'react'
import SliderGallery from '../components/SliderGallery'

const TerrazzoGallery = () => {

  const galleryImages = [
    {
      img: "/assets/Terrazzo/terrazzodeck1.png",
      alt:'Dec-Tec membrane in various applications and settings 1'
    },
    {
      img: "/assets/Terrazzo/terrazzodeck3.png",
      alt:'Dec-Tec membrane in various applications and settings 2'
    },
    {
      img: "/assets/Terrazzo/terrazzodeck4.png",
      alt:'Dec-Tec membrane in various applications and settings 3'
    },
    {
      img: "/assets/Terrazzo/terrazzodeck5.png",
      alt:'Dec-Tec membrane in various applications and settings 4'
    },
    {
      img: "/assets/Terrazzo/terrazzodeckmockup.png",
      alt:'Dec-Tec membrane in various applications and settings 5'
    }
  ]

  return (
    <div>
      <SliderGallery
        title="Terrazzo"
        para1="Discover the perfect balance of exceptional design and proven performance with Terrazzo. Inspired by today's most sought-after architectural finishes, Terrazzo brings sophisticated style, lasting durability, and trusted waterproof protection together in one premium walkable membrane. Elevate every outdoor space with a surface that's designed to impress, engineered to endure, and built to create unforgettable places to live, gather, and enjoy."
        galleryImages={galleryImages}
        previouslink="/products/membranes/classic-line"
        nextlink="/harland-gallery/"
      />
    </div>
  )
}

export default TerrazzoGallery
